import repository from '@/utils/repository';

const resource = '/move/MNG_Order006';

export default {
    search: (data) => {
        return repository.post(`${resource}/search`, {
            ...data
        });
    }
};
